import { render, staticRenderFns } from "./UserPaymentsDataTable.vue?vue&type=template&id=7ca162c3"
import script from "./UserPaymentsDataTable.vue?vue&type=script&lang=js"
export * from "./UserPaymentsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports